var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1309 15.1346C11.1309 14.1954 11.9117 13.434 12.8747 13.434H20.652V5.1657C20.652 4.18447 19.5607 3.5105 19.1081 3.5105H8.12457L3.18878 8.09811L3.41408 23.0312C3.42222 23.5709 3.85453 24.0067 4.39423 24.0159C6.35966 24.0493 10.6785 24.1223 11.1309 24.1272V15.1346ZM16.6105 24.1047C17.6823 24.1047 18.7103 23.7942 19.4682 23.0755C20.2262 22.3569 20.652 21.3822 20.652 20.3659V16.8362H14.6185V24.1547C15.23 24.1464 15.894 24.1297 16.6105 24.1047ZM0 7.29336C0 6.78211 0.202404 6.29627 0.554323 5.96277L6.49284 0.424928C6.78214 0.150776 7.15116 0 7.53285 0H21C22.6569 0 24 1.34315 24 3V20.3655C24 22.2238 23.2215 24.0059 21.8356 25.3199C20.4498 26.6339 18.5702 27.3721 16.6104 27.3721C15.1217 27.4248 12.1354 27.4406 11.0801 27.4196C10.5547 27.4091 6.1032 27.4159 3.00516 27.422C1.34544 27.4253 0 26.0809 0 24.4212V7.29336Z",
    fill: "#008CFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileImage);
export default __webpack_public_path__ + "static/media/file-image.79dd44ed24f1d9e1909048e602e49f7e.svg";
export { ForwardRef as ReactComponent };